<template>
  <v-card max-width="400">
    <v-toolbar dense>
      <v-toolbar-title style="font-size: 18px; color: #555">
        {{ $t('actions.notifications') }}
      </v-toolbar-title>

      <v-spacer />

      <v-btn icon @click="markAllSilenced">
        <v-icon>done_all</v-icon>
      </v-btn>
    </v-toolbar>
    <Notifications />
  </v-card>
</template>
<script>
import { mapActions } from 'vuex';
import Notifications from './Notifications';
import { types as notificationsTypes } from '../../store/notifications';

export default {
  name: 'NotificationsMenu',
  components: {
    Notifications,
  },
  methods: {
    ...mapActions({
      markAllSilencedAction: notificationsTypes.actions.markAllSilenced,
    }),
    markAllSilenced() {
      console.log('mark all silenced');
      this.markAllSilencedAction();
    },
  },
};
</script>
